import { useCurrencyHelpers } from '@/lib/hooks/use-currency-helpers';
import React from 'react';

interface Props {
    children: string | number | undefined | null;
    currency?: string;
    decimals?: number;
    showEmptyIfZero?: boolean;
    emptyText?: string;
    showPlusSignIfPositive?: boolean;
}

export const CurrencyOrEmpty: React.FC<Props> = ({
    decimals = 0,
    currency,
    children,
    emptyText = '-',
    showEmptyIfZero = false,
    showPlusSignIfPositive = false,
}) => {
    const { formatCurrency } = useCurrencyHelpers();

    const formattedValue = formatCurrency(children, {
        decimals,
        currency,
        showEmptyIfZero,
        emptyText,
        showPlusSignIfPositive,
    });

    return <>{formattedValue}</>;
};
